module.exports = __webpack_public_path__ + "static/img/couch2.e669dd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/drawing_painting/couch/couch2.jpg
// module id = nzwM
// module chunks = 1